export { default } from './CustomBreadcrumbs'
export type { CustomBreadcrumbsProps, LinkPart } from './CustomBreadcrumbs'
